import axios from 'axios';
import getServiceCaseActionBaseUrl from './serviceCaseActionUrl';

import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';

const baseUrl = getServiceCaseActionBaseUrl();

function post(postUrl, postData) {
  return axios({
    method: 'post',
    url: `${baseUrl}${postUrl}`,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}
export function submitTakeActionResponse(respondIssuerObject, caseNumber) {
  const Url = `api/v1/cases/${caseNumber}/record/action`;
  configureHttpHeaders(axios);
  return post(`${Url}`, respondIssuerObject);
}

export function validateIssuerSentDocs(issuerDocData, caseNumber) {
  const Url = `api/v1/cases/${caseNumber}/validate/issuer/docs`;
  configureHttpHeaders(axios);
  return post(`${Url}`, issuerDocData);
}
